import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function HomeSlider() {
  const settings = {
    dots: false,         
    arrows: false,        
    infinite: true,
    speed: 800,
    slidesToScroll: 1,
    autoplay: true,       
    autoplaySpeed: 2000,  
  };

  return (
    <div className="home-slider-container-bg">


<div className="home-slider-main-container-bg">

  <div className="slider-container">
      <Slider {...settings}>
        <div className="slider-row">
          <img src="https://fubs.in/cdn/shop/files/DESKTOP_BANNER.jpg?v=1764328839&width=2400"></img>
        </div>
        <div className="slider-row">
          <img src="https://fubs.in/cdn/shop/files/CHRISTMAS_BANNER_DISKTOP_6.jpg?v=1765522052&width=2400"></img>
        </div>
        <div className="slider-row">
          <img src="https://fubs.in/cdn/shop/files/DESKTOP_BANNER.jpg?v=1764328839&width=2400"></img>
        </div>
        <div className="slider-row">
          <img src="https://fubs.in/cdn/shop/files/CHRISTMAS_BANNER_DISKTOP_6.jpg?v=1765522052&width=2400"></img>
        </div>
         <div className="slider-row">
          <img src="https://fubs.in/cdn/shop/files/DESKTOP_BANNER.jpg?v=1764328839&width=2400"></img>
        </div>
        <div className="slider-row">
          <img src="https://fubs.in/cdn/shop/files/CHRISTMAS_BANNER_DISKTOP_6.jpg?v=1765522052&width=2400"></img>
        </div>
        
      </Slider>
    </div>


</div>

    </div>
  );
}

export default HomeSlider;
